import React from "react";
import IPagination from "./Pagination";
import { LeftArrowsIcon, RightArrowsIcon } from "../../../assets/Icons";
import clsx from "clsx";

const Pagination: React.FunctionComponent<IPagination.IProps> = (props) => {
  const {
    pageSize,
    currentPage,
    siblingButtonClassname,
    siblingIconClassname,
    totalItems,
    setPagination,
    pagination,
  } = props;
  const totalPages = pagination?.totalPages || 1;

  const handlePrevClick = () => {
    if (currentPage !== undefined && currentPage > 0) {
      if (setPagination) {
        setPagination((prev) => ({
          ...prev,
          page: prev.page - 1,
        }));
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  const handleNextClick = () => {
    if (currentPage !== undefined && currentPage < totalPages - 1) {
      if (setPagination) {
        setPagination((prev) => ({
          ...prev,
          page: prev.page + 1,
        }));
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    }
  };

  const handlePageSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    if (setPagination) {
      setPagination((prev) => ({
        ...prev,
        size: parseInt(e.target.value),
      }));
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  };

  const firstPage = () => {
    const startRow = (currentPage || 0) * (pageSize || 10) + 1;
    const endRow = Math.min(startRow + (pageSize || 10) - 1, totalItems || 0);

    return <span className={clsx("mr-2 hidden md:block")}>{`${startRow}-${endRow}`}</span>;
  };

  return (
    <div className={clsx("flex w-full items-center justify-between text-sm py-3")}>
      <div className="flex w-full justify-start items-center">
        {firstPage()}
        <span>of {totalItems || 0}</span>
      </div>
      <div className="w-full flex justify-end">
        <p className="flex px-3 justify-start items-center">
          <span>Rows per page:</span>
          <select defaultValue={10} value={pagination?.size} onChange={handlePageSizeChange}>
            {[10, 20, 30, 40, 50].map((list, index) => (
              <option value={list} key={index}>
                {list}
              </option>
            ))}
          </select>
        </p>
        <button
          className={clsx(
            `relative inline-flex p-2 overflow-hidden font-bold text-gray-100 bg-transparent rounded-lg cursor-pointer disabled:bg-transparent disabled:opacity-50 disabled:cursor-not-allowed mx-2 ${
              currentPage && currentPage > 0 && "border border-gray-200"
            }`,
            siblingButtonClassname,
          )}
          onClick={handlePrevClick}
          type={"button"}
          disabled={currentPage && currentPage === 0 ? true : false}
        >
          <i
            className={clsx(
              "flex flex-shrink-0 w-4 h-4 text-blue-600 fill-current",
              siblingIconClassname,
            )}
          >
            <LeftArrowsIcon />
          </i>
        </button>

        <button
          className={clsx(
            `relative inline-flex p-2 overflow-hidden border border-gray-200 font-bold text-gray-100 bg-transparent rounded-lg cursor-pointer disabled:bg-transparent disabled:opacity-50 disabled:cursor-not-allowed ${
              currentPage && currentPage >= totalPages - 1 && "border border-gray-200"
            }`,
            siblingButtonClassname,
          )}
          onClick={handleNextClick}
          type={"button"}
          aria-label={"Next"}
          disabled={currentPage && currentPage >= totalPages - 1 ? true : false}
        >
          <i
            className={clsx(
              "flex flex-shrink-0 w-4 h-4 text-blue-600 fill-current",
              siblingIconClassname,
            )}
          >
            <RightArrowsIcon />
          </i>
        </button>
      </div>
    </div>
  );
};

export default Pagination;
